import { QueryDocumentSnapshot } from '@firebase/firestore';

import { type Banner } from '../admin/BannerManagement/constants.ts';

export const bannerConverter = {
  toFirestore: (banner: Banner) => banner,
  fromFirestore: (snapshot: QueryDocumentSnapshot) => snapshot.data() as Banner,
};
